import styled from "styled-components";
import Popover from "@mui/material/Popover";

import { breakpoints } from "@/styles/breakpoints";

export const StyledHelpPopover = styled(Popover)`
    .popover-paper {
        margin-top: 10px;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
        border-radius: var(--radius-5);

        .helpTitle {
            display: flex;
            align-items: center;
            width: 312px;
            padding: 8px 16px 0 16px;
            font-size: var(--size-14);
            font-style: normal;
            font-weight: bold;
            line-height: 19px;
            color: var(--color-primary);
            background-color: var(--color-white);
            @media ${breakpoints.xs} {
                width: 190px;
            }
        }

        .helpMessage {
            width: 312px;
            padding: 8px 16px;
            font-size: var(--size-14);
            font-style: normal;
            font-weight: normal;
            line-height: 19px;
            color: var(--color-grey-900);
            background-color: var(--color-white);

            a {
                color: var(--color-grey-900);
                text-decoration: none;
                cursor: pointer;

                &.isDisabled {
                    pointer-events: none;
                    cursor: default;
                }
            }

            @media ${breakpoints.xs} {
                width: 190px;
                font-size: var(--size-14);
                a {
                    color: var(--color-primary);
                }
            }
        }
    }
`;
